define( function() {
	"use strict";

	return Object.getPrototypeOf;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/getProto.js
// module id = 379
// module chunks = 27